import { MsalAuthProvider, LoginType } from "react-aad-msal";
const rUrl = window.location.protocol + '//' + window.location.host;
const config = {
    auth: {
        authority: 'https://login.microsoftonline.com/d3de0d00-8a93-4045-9b9a-e19b9fbdbe2b',
        clientId: 'da129e64-5a9e-49ad-9b77-1bc14d59c46a',
        redirectUri: rUrl
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true
    }
};  

const authenticationParameters = {
    scopes: [
        'api://da129e64-5a9e-49ad-9b77-1bc14d59c46a/Reports'
    ]
}

const options = {
    loginType: LoginType.Redirect,
    tokenRefreshUri: window.location.origin + '/auth.html'
}

export const authProvider = new MsalAuthProvider(config, authenticationParameters, options) 